import { Grid } from "@mui/material";

const GridItemTwoColumnProfileInfo = ({ children }) => {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={6}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {children}
    </Grid>
  );
};

export default GridItemTwoColumnProfileInfo;
